<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<h1 style="color: #2d8cf0;">4.3、表增加字段</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp;
						&nbsp;给数据库里已经存在的表增加字段，我们之前的做法是将表删除了，然后重新创建表。在表创建初期这么做完全可以，但是如果现在表里已经有数据了，就不能这么做了，因为一旦删除表，表里的数据也将一起被删除。这时就需要用到给现有的表增加字段的语句。
					</div>
					<h2 class="about-cs">4.3.1概念</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; 给表添加字段就好比菜老板想把“商品信息表”增加一个供货商字段的这个过程。
					</div>
					<h2 class="about-cs">4.3.2添加字段语句</font>
					</h2>
					<div class="about-t">


						&nbsp; &nbsp;&nbsp; &nbsp; 样例:<br />
						<!-- 在这里传入后台返回的文本数据和关键字就可以了 -->
						<!-- <change-key-word keyword="关键字" text="这一行有一个关键字"> </change-key-word><br /> -->


						<sql-show value="ALTER TABLE PRODUCT_T ADD SUPPLIERS VARCHAR(300);"> </sql-show>


						解释：<br />
						<change-key-word keyword="ALTER TABLE:" text="ALTER TABLE: 固定的告诉数据库这是一条修改表结构的语句。">
						</change-key-word><br />
						<change-key-word keyword="PRODUCT_T:" text="PRODUCT_T:是修改对象，这里就是商品信息表"> </change-key-word><br />

						<change-key-word keyword="ADD:" text="ADD:是要增加字段的意思。">
						</change-key-word><br />
						<change-key-word keyword="SUPPLIERS: " text="SUPPLIERS: 是“供货商”的意思，这是我们要增加的字段。">
						</change-key-word><br />
						<change-key-word keyword="VARCHAR(300):" text="VARCHAR(300):是新增字段的字段类型。">
						</change-key-word><br />
					 <div style="padding-left: 50px;">
							<img style="width: 40px;" :src="require('../../assets/image/jiantou.png')">
							<a @click="toRunSql">打开我的在线sql学习编辑器 </a></br>
						</div>



						查看数据表结构：
						<img style="width: auto;" :src="require('../../assets/sql/select16.png')"> </br>
						说明：在没有删除表重建的情况下新增了一个字段名为SUPPLIERS 字段类型为VARCHAR(300)的字段，新增的字段数据都为空。</br>
						</br>
						补充说明：上面只讲到了表字段的增加，表字段和字段的类型能不能修改？能不能删除？基础的sql语法里有相应的语句，但是实际中很少使用。而且修改和删除语句还受已有数据的限制，比如本来表PRODUCT_T中的商品字段PRODUCT_NAME是VARCHAR(200)
						，里面已经有一些数据商品名称的长度达到了100以上。这时你想通过语句把字段PRODUCT_NAME的数据类型改成VARCHAR(100)给他减少100，甚至把它改成INT类型的数据，能改成功么？肯定改不成。实际工作中几乎没有使用过，所以这里就讲了。


					</div>
					<div>
						<Modal v-model="modal1" title="购买服务" @on-cancel="cancel">
							<Form :label-width="150">
								<Row>
									<Col align="center" :span="24">
									<div style="font-size: 50px;">微信支付</div>
									<div style="font-size: 22px;">在线sql学习服务<span style="color: red;">20元，有效期一个月</span>
									</div>
									<div ref="twoImageRef" id="twoImageId"></div>
									<div></div>
									<div style="font-size: 22px;">在线sql学习服务<span style="color: red;">100元，有效期一年</span>
									</div>
									<div ref="twoImageYearRef" id="twoImageIdYear"></div>
									</Col>
								</Row>
							</Form>
							<!-- 这里去掉确认和取消按钮 -->
							<div slot="footer"></div>
						</Modal>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import ChangeKeyWord from '@/components/project/ChangeKeyWord.vue'
	import QRCode from 'qrcodejs2'
	import {
		getIfPay,
		createTwoImage
	} from '@/network/index.js';
	import SqlShow from '@/components/project/SqlShow.vue'
	export default {
		components: {
			ChangeKeyWord,
			SqlShow,
		},

		data() {
			return {
				userId: '',
				ifLogin: false,
				ifMoney: 0,
				modal1: false,

			}
		},
		mounted() {
			this.checkPayStatus()
		},

		created() {
			this.userId = this.$store.state.userInfo.userId;
			if (this.userId != undefined) {
				this.ifLogin = true;
			}
			console.log('userId:' + this.userId);
		},
		computed: {

		},
		methods: {

			checkPayStatus() {
				//付费校验
				if (this.ifLogin == true) {
					getIfPay().then(res => {
						// console.log(res);
						this.ifMoney = res.data.obj;
						if (this.ifMoney == 1) {
							//关闭弹出窗
							this.modal1 = false
						} else {
							setTimeout(() => {
								this.checkPayStatus() // 等待一段时间后再次调用checkPayStatus方法
							}, 1000)
						}
					})
				}

			},
			cancel() {
				this.modal1 = false
			},

			//生成二维码
			generateQRCode(classId, value) {
				new QRCode(document.querySelector(classId), {
					text: value,
					width: 180,
					height: 180,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H
				})
			},

			toRunSql() {
				//判断是否登录
				if (this.ifLogin == true) {
					getIfPay().then(res => {
						// console.log(res);
						this.ifMoney = res.data.obj;
						//有效期内
						if (this.ifMoney == 1) {
							let routeUrl = this.$router.resolve({
								path: '/run',
							})
							window.open(routeUrl.href, '_blank')

						} else {
							//生成收费的二维码
							let paramter = {
								attach: this.$store.state.userInfo.loginId,
								money: 20000,
								//money: 1,
							};

							//清空之前的二维码 否则会生成多个
							this.$refs.twoImageRef.innerHTML = '';
							createTwoImage(paramter).then(res => {
								this.twoImage = res.code_url;
								this.generateQRCode("#twoImageId", this.twoImage);
							}).catch(error => {});


							let paramterYear = {
								attach: this.$store.state.userInfo.loginId,
								money: 100000,
								//money: 2
							};

							//清空之前的二维码 否则会生成多个
							this.$refs.twoImageYearRef.innerHTML = '';
							createTwoImage(paramterYear).then(res => {
								this.twoImageYear = res.code_url;
								this.generateQRCode("#twoImageIdYear", this.twoImageYear);
							}).catch(error => {});

							//弹出对话框，要求付费
							this.modal1 = true
						}

					}).catch(error => {});

				} else {
					this.$router.push('/login');
				}
			},

		},

	}
</script>

<style lang="scss" scoped>
	//写上样式
	.keyWord {
		color: #0fbda0;
	}


	#vip {
		color: red;
	}

	.about-xs {
		margin-bottom: 20px;
		margin-top: 10px;
	}

	//标题字体
	.aw-register-box .mod-body .content h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	//内容字体	
	.aw-register-box .mod-body .content .about-t {
		width: 1040px;
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}


	.aw-register-box .mod-body .content .about-t .at-r {
		width: 596px;
		height: auto;
		float: right;
		text-align: center;
	}

	.aw-register-box .mod-body {
		padding: 10px 10px 10px 10px;
	}

	.aw-register-box .gxgd {
		padding: 10px 10px 10px 10px;
	}


	.about-box {
		width: 1170px;
		margin: 20px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}




	.aw-register-box .mod-body .content .about-t .at-l {
		width: 442px;
		height: auto;
		padding-top: 80px;
		float: left;
		text-align: left;
	}

	.aw-register-box .mod-body .content .about-t .at-l2 {
		width: 496px;
		height: auto;
		float: left;
		text-align: center;
	}

	.aw-register-box .mod-body .content h2.about-cs font {
		color: #e37626;
		font-size: 24px;
	}

	.aw-register-box .mod-bodyx .content h2 {
		margin: 0 0 13px 0;
		color: #333;
		font-size: 18px;
	}

	.aw-register-box .mod-body .content h2.t-center {
		text-align: center;
	}

	.aw-register-box .mod-body .mod-bodyt h2.t-center {
		text-align: center;
	}

	h2.about-little {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 20px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}
</style>
